import { Brands } from '../constants.js';

var logoDefaultValues = {
  Brand: Brands.DoorDash
};

export { logoDefaultValues };
